import { read, utils } from 'xlsx';

export function getMatrixFromXLS(blob) {
  const workbook = read(blob, { type: 'array' });

  const sheetName =
    workbook.SheetNames.indexOf('Raw data') > -1
      ? 'Raw data'
      : workbook.SheetNames[0];

  return utils.sheet_to_json(workbook.Sheets[sheetName], {
    header: 1,
  });
}
